import { getAdminOffset, getViewportWidth } from './helper/helper';

(function () {

	class StickyElement {

		constructor(sticky) {
			this.offset = 0;
			this.sticky = sticky;
			this.container = null;
			this.breakpoint = '';
			this.placeholder = null;

			if (!this.sticky) {
				return;
			}

			this.create()
		}

		create() {
			this.container = this.sticky.closest('.hpy-is-sticky-container');
			if (!this.container) {
				return;
			}
			this.container.style.position = 'relative';
			this.container.style.height = '100%';

			if (window?.hpy_sizes && this.container.dataset?.stickyBreakpoint) {
				this.breakpoint = window.hpy_sizes[this.container.dataset.stickyBreakpoint]
			}

			this.maybeStick();
			document.addEventListener('scroll', this.maybeStick.bind(this), { passive: true });
			document.addEventListener('resize', this.maybeStopAtBreakpoint.bind(this), { passive: true });
		}

		maybeStick() {
			if (this.isBreakpoint()) {
				if (this.sticky.classList.contains('is-stuck')) {
					this.unstick();
				}

				return;
			}
			let offset = this.offset + getAdminOffset();
			// add placeholder to fill space of the sticky element
			this.placeholder = this.container.querySelector('.hpy-sticky-placeholder')
			if (!this.placeholder) {
				this.placeholder = document.createElement('div');
				this.placeholder.className = 'hpy-sticky-placeholder';
				this.placeholder.style.width = '100%';
				this.sticky.insertAdjacentElement('beforebegin', this.placeholder);
			}

			this.placeholder.style.height = this.sticky.offsetHeight + 'px';
			const containerRect = this.container.getBoundingClientRect();

			if ((containerRect.top - offset) <= 0) {
				this.sticky.style.left = containerRect.left;
				this.sticky.style.right = containerRect.right;
				this.sticky.style.width = `${containerRect.width}px`;
				this.sticky.classList.add('is-stuck');

				if ((containerRect.bottom - offset - this.sticky.offsetHeight) < 0) {
					this.sticky.style.position = 'absolute';
					this.sticky.style.bottom = 0;
					this.sticky.style.top = '';
				} else {
					this.sticky.style.position = 'fixed';
					this.sticky.style.top = `${offset}px`;
					this.sticky.style.bottom = '';
				}
				this.placeholder.style.display = 'block';
			} else {
				this.unstick();
			}
		}

		unstick() {
			this.sticky.classList.remove('is-stuck');
			this.sticky.style.position = '';
			this.sticky.style.left = '';
			this.sticky.style.right = '';
			this.sticky.style.width = '';
			this.sticky.style.top = '';
			this.sticky.style.bottom = '';
			this.placeholder.style.display = 'none';
		}

		maybeStopAtBreakpoint() {
			if (this.isBreakpoint() && this.sticky.classList.contains('is-stuck')) {
				this.unstick();
			}

		}

		isBreakpoint() {
			return '' !== this.breakpoint && getViewportWidth() <= this.breakpoint;
		}
	}


	const stickyElements = [...document.querySelectorAll('.hpy-is-sticky-element')];
	if (stickyElements.length) {
		stickyElements.forEach(sticky => new StickyElement(sticky));
	}
})();



